import React from "react"
import PropTypes from "prop-types"
import ArrowDown from "../icons/ArrowDown.svg?react"
import styles from "./ExpandButton.module.sass"

const ExpandButton = (props) => {
  return (
    <a onClick={props.onClick} className={styles.button}>
      <span>{props.label}</span>
      <ArrowDown fill={props.color} />
    </a>
  )
}

ExpandButton.propTypes = {
  onClick: PropTypes.func,
  label: PropTypes.string,
  color: PropTypes.string,
}

export default ExpandButton
